"use client";

import { CandleSetupGroup, DataItem } from "@/types";
import { CandlePatternInfo } from "@/lib/candlePatternInfo";
import SignalWorkspace from "./SignalWorkspace";

interface PatternsTabProps {
  items: DataItem[];
  uniqueTypes: string[];
  setupGroups?: CandleSetupGroup[];
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
  selectedPatternInfo: CandlePatternInfo | null;
  trendFilter: "all" | "up" | "down";
  setTrendFilter: (filter: "all" | "up" | "down") => void;
  timeframe?: "daily" | "weekly" | "monthly";
}

export default function PatternsTab(props: PatternsTabProps) {
  return (
    <SignalWorkspace
      {...props}
      mode="patterns"
      title="Candlestick Pattern Scanner"
      description="Scan live candlestick families, review their directional bias, then open the names that fit the current trend context."
      emptyMessage="Select a candlestick family from the explorer to review the live matches and the pattern notes."
    />
  );
}
